module.exports = __webpack_public_path__ + "media/assets/img/register-2dd199e9fb4d118dbe152080f1367ed7.jpeg";